// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0acb6076","513":"2bdd149e","703":"029bf01e","787":"d3befce1"}[chunkId] + ".chunk.js";
};